/** @format */

import React, { useEffect, useState } from 'react';
import Typography from '../../../elements/Typography';
import classNames from 'classnames';
import styles from './guestinfo.module.css';
import { VISIT_QUESTIONS } from '../../../../constants/commons';
import { addGuestAnswer } from '../../../../services/home.service';
import useAppContext from '../../../hooks/useAppContext';

function GuestInfo() {
  return (
    <article className={classNames(styles['container'], 'container')}>
      <div className={classNames(styles['wrapper'])}>
        <Typography as="h3" className={classNames(styles['heading'])}>
          You're awesome! But just a few questions to get to know you better.
        </Typography>
        <Questions />
      </div>
    </article>
  );
}

function Questions() {
  return (
    <div className={classNames(styles['questions-wrapper'])}>
      {VISIT_QUESTIONS.map((question, index) => {
        return (
          <div
            key={question.qid}
            className={classNames(styles['question-wrapper'])}
          >
            <Typography as="p" className={classNames(styles['question'])}>
              {index + 1}. {question.question}
            </Typography>
            <Options options={question.options} qid={question.qid} />
          </div>
        );
      })}
    </div>
  );
}

function Options({ options, qid }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const { uuid, handleUUID } = useAppContext();
  const handleOptionClick = (option) => {
    setSelectedOption(option);
  };

  useEffect(() => {
    if (selectedOption) {
      const { oid, title } = selectedOption;
      const payload = {
        uuid: uuid || handleUUID(),
        qid,
        oid,
        title,
      };
      addGuestAnswer(payload);
    }
  }, [selectedOption]);

  return (
    <div className={classNames(styles['options-wrapper'])}>
      {options.map((option) => {
        return (
          <div
            key={option.oid}
            onClick={() => handleOptionClick(option)}
            className={classNames(
              styles['option'],
              selectedOption?.oid === option.oid && styles['clicked-option']
            )}
          >
            <img
              src={option.img}
              alt={option.title}
              className={classNames(styles['option-img'])}
            ></img>
            <Typography as="p" className={classNames(styles['option-text'])}>
              {option.title}
            </Typography>
          </div>
        );
      })}
    </div>
  );
}

export default GuestInfo;
